/**
 * Whether a return address stays on the origin it was resolved against.
 *
 * Pattern-matching a leading slash is not enough: the URL parser treats `\` as
 * an authority separator, so `/\evil.example` leaves this origin. Resolving the
 * candidate against the origin and comparing origins is the rule that actually
 * keeps a redirect here.
 */
export function isOnOrigin(
  candidate: string | null | undefined,
  origin: string,
): candidate is string {
  if (!candidate) return false
  try {
    return new URL(candidate, origin).origin === new URL(origin).origin
  } catch {
    return false
  }
}
